
import { Challenge } from '../../types/game';

export const bitcoinHalvingChallenge: Challenge = {
  id: 'bitcoin-halving',
  title: 'Bitcoin Halving Event',
  description: 'A Bitcoin halving has cut block rewards in half. How do you adjust your strategy?',
  options: [
    {
      text: 'Upgrade to more efficient mining hardware',
      outcome: 'The efficiency gains offset much of the reward reduction.',
      kpiEffects: {
        efficiency: 8,
        profitMargin: -3
      },
      experienceGain: 20
    },
    {
      text: 'Reduce operational costs',
      outcome: 'Cost-cutting measures preserved profitability but at the expense of some operational capacity.',
      kpiEffects: {
        energyCost: -0.01,
        uptime: -2
      },
      experienceGain: 15
    },
    {
      text: 'Diversify into other crypto mining',
      outcome: 'Diversification provided additional revenue streams but divided your focus.',
      kpiEffects: {
        profitMargin: 2,
        efficiency: -3
      },
      experienceGain: 25
    }
  ],
  difficulty: 5
};
